var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlt1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41667 0.75V3.63889M3.63889 0.75V3.63889M0.75 6.52778H12.3056M0.75 3.63889C0.75 3.2558 0.902182 2.8884 1.17307 2.61751C1.44395 2.34663 1.81135 2.19444 2.19444 2.19444H10.8611C11.2442 2.19444 11.6116 2.34663 11.8825 2.61751C12.1534 2.8884 12.3056 3.2558 12.3056 3.63889V12.3056C12.3056 12.6886 12.1534 13.056 11.8825 13.3269C11.6116 13.5978 11.2442 13.75 10.8611 13.75H2.19444C1.81135 13.75 1.44395 13.5978 1.17307 13.3269C0.902182 13.056 0.75 12.6886 0.75 12.3056V3.63889Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlt1);
export default __webpack_public_path__ + "static/media/flt1.79759130f5222ca34590f25176669463.svg";
export { ForwardRef as ReactComponent };